import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ListGroup, Dropdown } from 'react-bootstrap';
// import avatar1 from '../../../../assets/images/user/usernew1.png';
import avatar1 from '../../../assets/images/user/usernew1.png';

import NavLeft from './NavLeft';
import NavRight from './NavRight';

import { ConfigContext } from '../../../contexts/ConfigContext';
import * as actionType from '../../../store/actions';
import wellinton from '../../../../src/assets/images/wellington2.png';
// import clientclublogow from '../../../../src/assets/images/WGC-logo.png';
import customersupport from '../../../assets/images/customer_support_white.png';
import home from '../../../assets/images/home.png';


import img from '../../../assets/images/logo/Belur.jpeg';
import axios from 'axios';

const NavBar = () => {
  const navigate = useNavigate();
  const [iconphone, setIconphone] = useState(false);
  const [membername, setMemberName] = useState('');
  const [memberType, setMemberType] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [moreToggle, setMoreToggle] = useState(false);

  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem('loginData'));
    setMemberType(loginData?.userType);
    setMemberName(loginData?.userName);
  }, []);

  const [data, setData] = useState([]);
  const [memId, setMemid] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    const memberId = localStorage.getItem('memberId');
    const userType = localStorage.getItem('usertype');

    if (userType === 'Member') {
      getdata(token, memberId);
    }
    setMemid(memberId);
  }, []);
  const dropdownRef = useRef(null);
  const configContext = useContext(ConfigContext);
  const { collapseMenu, headerBackColor, headerFixedLayout, layout, subLayout } = configContext.state;
  const { dispatch, state } = configContext;


  const getdata = async (token, id) => {
    const h = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    try {
      const params = `?MemberID=${id}`;
      const { data } = await axios.get(`${window.BASE}${window.NOTIFICATION_GET}${params}`, { headers: h });
      setData(data.trnNotifications);
      dispatch({ type: 'Notification', notify: count(data.trnNotifications) });
    } catch (error) { }
  };

  const count = (notifications) => {
    const c = notifications.filter((notification) => notification.read == 0);
    return c.length;
  };

  let headerClass = ['navbar', 'pcoded-header', 'navbar-expand-lg', headerBackColor];
  if (headerFixedLayout && layout === 'vertical') {
    headerClass = [...headerClass, 'headerpos-fixed'];
  }

  let toggleClass = ['mobile-menu'];
  if (collapseMenu) {
    toggleClass = [...toggleClass, 'on'];
  }

  const navToggleHandler = () => {
    dispatch({ type: actionType.COLLAPSE_MENU });
  };

  const handlePhone = () => {
    window.open(`tel:${8925915429}`);
    setIconphone(!iconphone);
  };

  const handleChat = () => {
    navigate('/chat-page');
  };

  const handleProfile = () => {
    navigate('/myprofile');
    window.location.reload();
  };

  const changePassword = () => {
    navigate('/changepassword');
    window.location.reload();
  };

  const handleLogout = async () => {
    localStorage.setItem('key', 'false');
    localStorage.clear();
    navigate('/auth/signin-1');
    window.location.reload();
  };

  const handleHome = () => {
    const user = localStorage.getItem('usertype');

    if (user === 'Member') {
      navigate('/member-dashboard');
      window.location.reload();
    } else {
      navigate('/admin-dashboard');
      window.location.reload();
    }
  };

  const handlebacktohome = () => {
    const user = localStorage.getItem('usertype');

    if (user === 'Member') {
      navigate('/pre-dash')
      window.location.reload();
    } else {
      navigate('/admin-dashboard');
      window.location.reload();
    }
  }
  // const handleClickOutside = (event) => {
  //   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //     setMoreToggle(false);
  //     setDropdownVisible(false);
  //   }
  // };
  // useEffect(() => {
  //   if (dropdownVisible || moreToggle) {
  //     document.addEventListener('mousedown', handleClickOutside);
  //   } else {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, [dropdownVisible, moreToggle]);

  const handleImageClick = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const handleMoreToggle = () => {
    setMoreToggle(!moreToggle);
    setDropdownVisible(!dropdownVisible);
  };

  const [member, setMember] = useState({
    name: '',
    type: ''
  });
  const { name, type } = member;

  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem('loginData'));
    setMemberType(loginData?.userType);
    setMemberName(loginData?.userName);
    const memberData = JSON.parse(localStorage.getItem('memberData'));
    if (memberData !== null && Object.keys(memberData).length > 0) {
      setMember((prev) => ({
        ...prev,
        name: memberData[0].membername,
        type: memberData[0].membertype
      }));
    }
  }, []);
  const isWidth = window.innerWidth > 990;

  let navBar = (
    <React.Fragment>
      <div className="m-header" ref={dropdownRef}>
        <Link to="#" className={toggleClass.join(' ')} id="mobile-collapse" onClick={navToggleHandler}>
          <span />
        </Link>
        {/* <Link to="#" className="b-brand club-logo">
          <img id="main-logo" src={wellinton} alt="" className="logo" onClick={handleHome} />
        </Link> */}

        {/* <Link  className="b-brand club-logo">
         WGC
        </Link> */}
        {/* ADD Phone call link */}

        {memberType === 'Member' && (
          <>
           
            <Link to="#" className="b-brand club-logo">
              <img id="main-logo" src={img} alt="" className="logo" onClick={handleHome} />
            </Link>

            {/* <Link to="#" style={{ marginRight: '110px' }} className="mob-toggler" >
              <i className="fa-solid fa-home" style={{ width: '29px', height: '29px', color: 'white' }}  />

            </Link> */}


            <Link to="#" style={{ marginRight: '30px' }} className="mob-toggler" onClick={handlePhone}>
              <img src={customersupport} style={{ width: '29px', height: '29px', color: 'white' }} />
            </Link>

            <div style={{ marginRight: '110px', marginTop: '8px', cursor: 'pointer' }} className="mob-toggler notification-icon">
              <i className="fa-solid fa-home" style={{ width: '29px', height: '29px', color: 'white' }} onClick={() => handlebacktohome()} />
            </div>

            <div style={{ marginRight: '70px', marginTop: '8px', cursor: 'pointer' }} className="mob-toggler notification-icon">
              <i className="fa-solid fa-bell" style={{ width: '29px', height: '29px', color: 'white' }} onClick={() => handleChat()} />
              {state?.notification > 0 && <div class="mob-count-child">{state?.notification}</div>}
            </div>
          </>
        )}
        <Link to="#" className="mob-toggler" onClick={handleMoreToggle}>
          <i className="feather icon-more-vertical" />
        </Link>

        {/* <Link to="#" className="mob-toggler" onClick={handleMoreToggle}>
          <i className="feather icon-more-vertical" />
        </Link> */}
        {/* <Link to="#" className="mob-toggler">
          <i className="fa-solid fa-bell" />
        </Link> */}
      </div>

      {isWidth ? (
        <>
          {memberType === 'Member' && (
            <>
              {' '}
              <div style={{ marginTop: '25px', cursor: 'pointer' }} className="mob-toggler pmob-parent cmob-count-parent notification-icon">
                <i className="fa-solid fa-bell" style={{ width: '29px', height: '29px', color: 'white' }} onClick={() => handleChat()} />
                {state?.notification > 0 && <div class="mob-count-child">{state?.notification}</div>}
              </div>
            </>
          )}

          <div style={{ justifyContent: 'end' }} className={`collapse navbar-collapse ${moreToggle ? 'd-block' : ''}`}>
            <NavLeft />
            <NavRight dropdownVisible={dropdownVisible} handleImageClick={handleImageClick} />
          </div>
        </>
      ) : (
        <div style={{ justifyContent: 'end' }} className={` ${moreToggle ? 'd-block' : ''}`}>
          <NavRight dropdownVisible={dropdownVisible} handleImageClick={handleImageClick} />
        </div>
      )}
    </React.Fragment>
  );

  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    navBar = <div className="container">{navBar}</div>;
  }

  return (
    <React.Fragment>
      <header className={headerClass.join(' ')}>{navBar}</header>
    </React.Fragment>
  );
};

export default NavBar;
